import JobProApi from '../../dependencies/JobProApi';
import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import { getNextCalendarDisplayOrder, getNextPurchaseOrderDeliveryOrder, reloadCalendar } from '../calendar';

const DISPATCH_EVENT = 'DISPATCH_EVENT';
const PREVIEW_EVENT = 'PREVIEW_EVENT';

const DEFAULT_STATE = {
  previewEvent: null
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case PREVIEW_EVENT:
      return {
        ...state,
        previewEvent: payload
      };
    default:
      return state;
  }
}

// Action creators
export const dispatchEvent = (eventId) => ({
  type: DISPATCH_EVENT,
  payload: { eventId }
});

export const previewEvent = (event) => ({
  type: PREVIEW_EVENT,
  payload: event
});

// Epics
export const dispatchEventEpic = (action$, state$) => action$.pipe(
  ofType(DISPATCH_EVENT),
  switchMap(({ payload }) => {
    const { calendar, events } = state$;
    const { activeCrew } = calendar;
    const { eventId } = payload;

    const event = events.events.find(e => e.id === eventId);
    if (event.purchaseOrder) {
      const deliveryOrder = getNextPurchaseOrderDeliveryOrder(events.events, activeCrew);
      return JobProApi.purchaseOrders.update(event.purchaseOrder.id, {
        crew: activeCrew ? {
          equipment: activeCrew.equipment ? { id: activeCrew.equipment.id } : null,
          resources: activeCrew.resources.filter(r => !!r.resource).map(r => ({
            resource: { id: r.resource.id }
          }))
        } : null,
        deliveryOrder
      }, {
          fields: 'id'
        });
    } else {
      const displayOrder = getNextCalendarDisplayOrder(events.events, activeCrew);
      return JobProApi.calendar.update(eventId, {
        crew: activeCrew ? {
          equipment: activeCrew.equipment ? { id: activeCrew.equipment.id } : null,
          resources: activeCrew.resources.filter(r => !!r.resource).map(r => ({
            resource: { id: r.resource.id },
            resourcePercentage: r.resourcePercentage
          }))
        } : null,
        displayOrder
      }, {
          fields: 'id'
        });
    }
  }),
  map(() => reloadCalendar()),
);
